import {SET_ORDER_TYPE_INITIAL} from 'new-constants/ordering-mode.constants';
import {OrderingModeState} from './ordering-mode.reducer.types';
import {REPEAT_ORDER_SUCCESS} from '../constants/api.constants';
import {START} from "../constants/app-state.constants";

const initialState: OrderingModeState = {
	orderingType: null,
};

export const orderingModeReducer = (previousState = initialState, action): OrderingModeState => {
	switch (action && action.type) {
		case SET_ORDER_TYPE_INITIAL:
			return {
				...previousState,
				orderingType: action.orderType,
			};
			break;
		case REPEAT_ORDER_SUCCESS:
			return {
				...previousState,
				orderingType: action.payload.orderingType
			};
			break;
		case START:{
			if(!action.returnFromAdyen) return previousState;

			return {
				...previousState,
				orderingType: action.returnFromAdyen.orderType
			}
		}

		default:
			return previousState;
	}
};
